//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppNavigation from '@nextcloud/vue/dist/Components/AppNavigation';
import AppNavigationItem from '@nextcloud/vue/dist/Components/AppNavigationItem';
import AppNavigationCounter from '@nextcloud/vue/dist/Components/AppNavigationCounter';
import Player from './Player';
export default {
  name: 'Navigation',
  components: {
    AppNavigation: AppNavigation,
    AppNavigationItem: AppNavigationItem,
    AppNavigationCounter: AppNavigationCounter,
    Player: Player
  },
  props: {
    stationData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isSearch: function isSearch() {
      return this.$route.name === 'SEARCH';
    }
  }
};